export enum enmContentType {
    Json = "application/json",
    FormData = "multipart/form-data",
}
